//let DbFunctions = require('./dbfunctions').DbFunctions
let okeResponse = require('okeoke.standardresponse')
let { UUID } = require("uuidjs")
import { storeData, getDataDB, getShiftDatasDB, getDocumentDatasDB, getUnsyncedDatas, cleanupDatas } from '../../IDB/data'
import ordereduuid from '../../Helpers/timeuuid'
import merge from 'lodash.merge'

let DocumentData = function (clientSocket, client) {
  const uid = UUID.generate()

  async function syncData(data) {
    return new Promise((resolve, reject) => {
      if (!clientSocket.authorized) {
        data.syncneeded = 1
        console.log('NOT CONNECTED', data.uuid, data.syncneeded)
        storeData(data)
        resolve({ success: false, message: 'Client not connected!' })
      } else {
        let done = false
        setTimeout(() => {
          if (!done) {
            data.syncneeded = 1
            console.log('TIMEOUT', data.uuid, data.syncneeded)
            storeData(data)
          }
          resolve({ success: false, message: 'Timeout!', code: 408, data: { errMsgCode: 'request.error.timeout' } })
        }, 5000)
        clientSocket.ioclient.emit(
          'syncDocumentData',
          {
            data
          },
          (e) => {
            done = true
            if (!e.success) {
              data.syncneeded = 1
              storeData(data)
            } else {
              data.syncneeded = 0
              storeData(data)
            }
            resolve(e)
          }
        )
      }
    })
  }

  async function addData(shiftUUID, documentUUID, dataType, data) {
    //if (!client.localUser?.userUUID) return okeResponse(false, 400, 'No user logged in', null)
    if (!client.tokenData?.deviceUUID) return okeResponse(false, 400, 'No device inited', null)
    let newData = {
      uuid: ordereduuid(),
      deviceUUID: client.tokenData?.deviceUUID,
      shiftUUID: shiftUUID,
      documentUUID,
      dataType,
      data,
      dataTimestamp: new Date().getTime(),
      sysUserUUID: client.localUser?.userUUID || null,
      syncneeded: 1
    }
    await storeData(newData)
    syncData(newData)
    return okeResponse(true, 201, 'Inserted', { ...newData })
  }

  async function updateData(data) {
    let existing = await getData(data.uuid)
    if(!existing.success) return okeResponse(false, 404, 'Not found', null)
    let updated = merge(existing.data, data)
    updated.syncneeded = 1
    syncData(updated)
    return res
  }

  async function syncOffline() {
    let datas = await getUnsyncedDatas()
    for await (let _dat of datas) {
      await syncData(_dat)
    }
  }

  function onConnectionChange(data) {
    switch (data.state) {
      case 'Authorized':
        syncOffline()
        break
      default:
        break
    }
  }

  async function init(shift) {
    if(!client.offlineEnabled) return
    let connected = clientSocket.authorized
    clientSocket.addCallback('onConnectionChange', uid, onConnectionChange)
    //console.log({shift})
    await cleanupDatas(shift?.uuid && shift.shiftEnd == null ? shift.uuid : null)
    if(connected) syncOffline()
  }

  async function getShiftDatas(shiftUUID) {
    let datas = await getShiftDatasDB(shiftUUID)
    return okeResponse(true, 200, 'Success', datas)
  }

  async function getDocumentDatas(documentUUID) {
    let datas = await getDocumentDatasDB(documentUUID)
    return okeResponse(true, 200, 'Success', datas)
  }

  async function getData(uuid) {
    let datas = await getDataDB(uuid)
    if(!datas) return okeResponse(false, 404, 'Not found', null)
    return okeResponse(true, 200, 'Success', datas)
  }

  return {
    init,
    addData,
    updateData,
    getShiftDatas,
    getDocumentDatas,
    getData,
    storeData
  }
}

export { DocumentData }